module.exports = __webpack_public_path__ + "static/media/second_tab.86824062.jpg";